import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Navbar from '../Navbar';
import Footer from '../Footer';
import Sidebar from '../Sidebar';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Redux/currentUserSlice';
import IP_URL from '../connect';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Papa from 'papaparse';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  AreaChart,
  Area,
  Legend,
} from 'recharts';

const Main = styled.div`
  min-height: 100vh;
  background: #f4f6f8;
`;
const Container = styled.div`
padding:20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-x: auto;
 
  @media(max-width: 600px) {
   padding: 10px;
  }
`;
const Content = styled.div`
  overflow-x: auto;
  
`;

/* Table styling (kept and slightly adjusted) */
const Table = styled.table`
  border-collapse: collapse;
  background-color: #fdfdfd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;

  th, td {
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    text-align: center;
    white-space: nowrap;
  }

  th {
    background-color: #1976d2;
    color: white;
    font-weight: bold;
  }

  tbody tr {
    transition: background 0.2s ease;
  }

  tbody tr:nth-child(odd) {
    background-color: #cce5f8ff;
  }

  tbody tr:hover {
    background-color: #e3f2fd;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    th, td {
      padding: 6px 8px;
    }
  }
`;

/* inputs & controls */
const Button = styled.button`
  background: ${(p) => (p.danger ? '#dc3545' : '#007bff')};
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

/* analytics cards */
const Cards = styled.div`
  display: flex;
  gap: 12px;
  margin: 12px 0;

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin: 5px 0;
  }
`;

const Card = styled.div`
  min-width:160px;
  padding:14px;
  border-radius:8px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.08);
  background: #fff;
  display:flex;
  flex-direction:column;
  gap:6px;
`;

const DataContainers = styled.div`
width:100%;
height:300px;
margin-bottom:50px;
box-shadow: 0 1px 6px rgba(0,0,0,0.08);


@media(max-width: 600px){
 height:250px;
}
`


/* --- Column picker + export picker UI --- */
const TableToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
  position: relative;
`;

const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
  padding: 10px 4px;
  font-size: 14px;
  color: #475569;

  .controls {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .page { min-width: 110px; text-align: center; }

  select {
    padding: 6px 8px;
    border-radius: 6px;
    border: 1px solid #35c0f3;
  }
`;

/* --- WaterBalance-style header, export buttons, and filter card --- */
const HeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const PageTitle = styled.div`
  h1 {
    font-size: 22px;
    font-weight: 700;
    color: #1a2b3c;
    margin: 0 0 4px;
  }
  p {
    color: #6b7c8c;
    margin: 0;
    font-size: 14px;
  }
`;

const ExportGroup = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;
`;

const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border: 1px solid ${(p) => (p.$primary ? '#2f80ed' : '#d8dee4')};
  border-radius: 8px;
  background: ${(p) => (p.$primary ? '#2f80ed' : '#fff')};
  color: ${(p) => (p.$primary ? '#fff' : '#2f4356')};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover:not(:disabled) { opacity: 0.88; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const ControlsBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: ${(p) => p.$wide ? '240px' : '180px'};
  flex: ${(p) => p.$wide ? '1 1 240px' : '0 0 auto'};

  label {
    font-size: 12px;
    font-weight: 600;
    color: #6b7c8c;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  input, select {
    padding: 8px 10px;
    border: 1px solid #d8dee4;
    border-radius: 8px;
    font-size: 14px;
    background: #fff;
    &:focus { outline: none; border-color: #2f80ed; }
  }
`;

/* neutral react-select styling to match the WaterBalance look */
const neutralSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '38px',
    border: `1px solid ${state.isFocused ? '#2f80ed' : '#d8dee4'}`,
    boxShadow: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover': { borderColor: '#2f80ed' },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#2f80ed' : state.isFocused ? '#eaf2fe' : '#fff',
    color: state.isSelected ? '#fff' : '#1a2b3c',
  }),
  singleValue: (provided) => ({ ...provided, color: '#1a2b3c' }),
  menu: (provided) => ({ ...provided, borderRadius: '8px', overflow: 'hidden', zIndex: 30 }),
};

const ColumnPickerPanel = styled.div`
  position: absolute;
  top: 42px;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  padding: 12px 14px;
  z-index: 20;
  min-width: 220px;
  max-height: 300px;
  overflow-y: auto;
`;

const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  font-size: 13px;
  cursor: pointer;

  input { cursor: pointer; }
`;

const PanelHeading = styled.div`
  font-weight: bold;
  font-size: 12px;
  color: #555;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 340px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 30px rgba(0,0,0,0.2);

  h3 { margin-top: 0; }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

const convertTime = (isoString) => moment(isoString).format('ddd, DD-MM-YY HH:mm');

/* Hardcoded columns for the DAILY (raw reading) view */
const DAILY_COLUMNS = [
  { key: 'deviceId', label: 'Serial No', accessor: (d) => d.deviceId, custom: false },
  { key: 'meterName', label: 'Meter Name', accessor: (d) => d.meterName, custom: false },
  { key: 'createdAt', label: 'Date', accessor: (d) => convertTime(d.createdAt), custom: false },
  { key: 'meterReading', label: 'Meter Reading (m³)', accessor: (d) => ((d.meterReading || 0) / 1000).toFixed(3), custom: false },
  { key: 'realFlowRate', label: 'Flowrate (m³/hr)', accessor: (d) => ((d.realFlowRate || 0) / 1000).toFixed(3), custom: false },
  { key: 'consumption', label: 'Consumption (m³)', accessor: (d) => ((d.consumption || 0) / 1000).toFixed(3), custom: false },
  { key: 'meterId', label: 'Meter Id', accessor: (d) => d.imei || d.meterId, custom: false },
];

/* Hardcoded columns for the MONTHLY (aggregated) view */
const MONTHLY_COLUMNS = [
  { key: 'deviceId', label: 'Serial No', accessor: (d) => d.deviceId, custom: false },
  { key: 'meterName', label: 'Meter Name', accessor: (d) => d.meterName, custom: false },
  { key: 'month', label: 'Month', accessor: (d) => d.monthLabel, custom: false },
  { key: 'meterReading', label: 'Meter Reading (m³)', accessor: (d) => (d.lastMeterReading ?? 0).toFixed(3), custom: false },
  { key: 'flowRate', label: 'Flow Rate (m³/hr)', accessor: (d) => (d.lastFlowRate ?? 0).toFixed(3), custom: false },
  { key: 'totalConsumption', label: 'Total Consumption (m³)', accessor: (d) => (d.totalConsumption ?? 0).toFixed(3), custom: false },
  { key: 'recordCount', label: 'Readings', accessor: (d) => d.recordCount, custom: false },
  { key: 'meterId', label: 'Meter Id', accessor: (d) => d.imei || d.meterId, custom: false },
];

/* Hardcoded columns for the YEARLY (aggregated) view */
const YEARLY_COLUMNS = [
  { key: 'deviceId', label: 'Serial No', accessor: (d) => d.deviceId, custom: false },
  { key: 'meterName', label: 'Meter Name', accessor: (d) => d.meterName, custom: false },
  { key: 'year', label: 'Year', accessor: (d) => d.yearLabel, custom: false },
  { key: 'meterReading', label: 'Meter Reading (m³)', accessor: (d) => (d.lastMeterReading ?? 0).toFixed(3), custom: false },
  { key: 'flowRate', label: 'Flow Rate (m³/hr)', accessor: (d) => (d.lastFlowRate ?? 0).toFixed(3), custom: false },
  { key: 'totalConsumption', label: 'Total Consumption (m³)', accessor: (d) => (d.totalConsumption ?? 0).toFixed(3), custom: false },
  { key: 'recordCount', label: 'Readings', accessor: (d) => d.recordCount, custom: false },
  { key: 'meterId', label: 'Meter Id', accessor: (d) => d.imei || d.meterId, custom: false },
];

// Turn camelCase / snake_case custom field keys into readable labels, e.g. "wspAccountNo" -> "Wsp Account No"
const prettifyKey = (key) =>
  key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/^./, (s) => s.toUpperCase())
    .trim();

const ConsumptionReport = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { token, uniqueKey } = useSelector(selectUser);
  const [loading, setLoading] = useState(true);

  // Server-computed summary (analytics + chart series + dropdown options + custom keys)
  const [summary, setSummary] = useState({
    analytics: { totalConsumption: 0, avgFlowRate: 0, peakFlowRate: 0, pointsCount: 0 },
    chartFlow: [],
    chartConsumption: [],
    meterOptions: [{ value: 'ALL', label: 'All meters' }],
    monthOptions: [{ value: 'ALL', label: 'All months' }],
    yearOptions: [{ value: 'ALL', label: 'All years' }],
    customFieldKeys: [],
  });

  // Paginated table rows for the current view/filters
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [refreshTick, setRefreshTick] = useState(0);

  const [selectedMeter, setSelectedMeter] = useState(null); // object { value, label }
  const [selectedMonth, setSelectedMonth] = useState(null); // { value: 'YYYY-MM', label } — monthly view only
  const [selectedYear, setSelectedYear] = useState(null);   // { value: 'YYYY', label } — yearly view only
  const [startDate, setStartDate] = useState(''); // yyyy-mm-dd — range view only
  const [endDate, setEndDate] = useState('');     // range view only
  const [singleDay, setSingleDay] = useState(''); // yyyy-mm-dd — daily view only
  const [exporting, setExporting] = useState(false);

  // Table view / period mode (mirrors the Water Balance "Filter By" modes):
  //  range  → raw readings across a start/end date range
  //  daily  → raw readings for a single day
  //  monthly/yearly → per-meter aggregates for the picked month/year
  const [view, setView] = useState('range'); // 'range' | 'daily' | 'monthly' | 'yearly'

  // --- column visibility + export selection state ---
  const [visibleColumns, setVisibleColumns] = useState({}); // { [key]: boolean }
  const [showColumnPicker, setShowColumnPicker] = useState(false);
  const [showExportPicker, setShowExportPicker] = useState(false);
  const [pendingExportFormat, setPendingExportFormat] = useState(null); // 'csv' | 'pdf'
  const [exportSelectedKeys, setExportSelectedKeys] = useState([]);

  const navigate = useNavigate();

  // Bounds (yyyy-mm-dd) for a "YYYY-MM" month key, used to narrow the monthly view
  const monthBounds = (monthKey) => {
    const [y, m] = monthKey.split('-').map(Number);
    const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
    return { from: `${monthKey}-01`, to: `${monthKey}-${String(last).padStart(2, '0')}` };
  };
  const yearBounds = (yr) => ({ from: `${yr}-01-01`, to: `${yr}-12-31` });

  // Monthly/yearly both hit the backend's aggregate endpoints; range/daily hit the
  // raw-readings (daily) endpoint with different bounds.
  const apiView = (view === 'monthly' || view === 'yearly') ? view : 'daily';

  // The active date filter — narrows to the picked range/day/month/year. Drives
  // BOTH the table rows and the summary (analytics + flowrate/consumption charts).
  const rowsDateFilter = () => {
    if (view === 'range') return { from: startDate, to: endDate };
    if (view === 'daily') return singleDay ? { from: singleDay, to: singleDay } : { from: '', to: '' };
    if (view === 'monthly') return (selectedMonth && selectedMonth.value !== 'ALL') ? monthBounds(selectedMonth.value) : { from: '', to: '' };
    if (view === 'yearly') return (selectedYear && selectedYear.value !== 'ALL') ? yearBounds(selectedYear.value) : { from: '', to: '' };
    return { from: '', to: '' };
  };

  // Shared query params for the meter + date filters
  const filterParams = (from, to) => {
    const p = new URLSearchParams({ uniqueKey });
    if (selectedMeter && selectedMeter.value !== 'ALL') p.set('meterId', selectedMeter.value);
    if (from) p.set('from', from);
    if (to) p.set('to', to);
    return p;
  };

  // Summary: refetched only when the meter/date filters change (not on page change)
  useEffect(() => {
    if (!uniqueKey) return;
    const ac = new AbortController();
    (async () => {
      try {
        const { from, to } = rowsDateFilter();
        const params = filterParams(from, to);
        const res = await fetch(`${IP_URL}/currentData/consumption-summary?${params}`, {
          headers: { Authorization: `Bearer ${token}` },
          signal: ac.signal,
        });
        if (!res.ok) throw new Error('Failed to load summary');
        setSummary(await res.json());
      } catch (err) {
        if (err.name !== 'AbortError') { console.error(err); toast.error('Error loading report summary.'); }
      }
    })();
    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueKey, token, selectedMeter, view, startDate, endDate, singleDay, selectedMonth, selectedYear, refreshTick]);

  // Rows: refetched when filters, view, selected month, or page/limit change
  useEffect(() => {
    if (!uniqueKey) return;
    const ac = new AbortController();
    (async () => {
      setLoading(true);
      try {
        const { from, to } = rowsDateFilter();
        const params = filterParams(from, to);
        params.set('view', apiView);
        params.set('page', String(page));
        params.set('limit', String(limit));
        const res = await fetch(`${IP_URL}/currentData/consumption-rows?${params}`, {
          headers: { Authorization: `Bearer ${token}` },
          signal: ac.signal,
        });
        if (!res.ok) throw new Error('Failed to load rows');
        const data = await res.json();
        setRows(data.rows || []);
        setTotal(data.total || 0);
        // If the row count shrank below the current page (e.g. a tighter filter or
        // a Refresh after data changed), snap back to a valid page.
        const lastPage = Math.max(1, Math.ceil((data.total || 0) / limit));
        if (page > lastPage) setPage(lastPage);
      } catch (err) {
        if (err.name !== 'AbortError') { console.error(err); toast.error('Error loading table data.'); }
      } finally {
        setLoading(false);
      }
    })();
    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueKey, token, selectedMeter, view, startDate, endDate, singleDay, selectedMonth, selectedYear, page, limit, refreshTick]);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  // Filter dropdown options + custom-column keys now come from the server summary
  const meterOptions = summary.meterOptions;
  const monthOptions = summary.monthOptions;
  const yearOptions = summary.yearOptions;
  const customColumnKeys = summary.customFieldKeys;

  // The table shows exactly the current page of server-filtered rows
  const tableRows = rows;

  // --- full column registry = hardcoded (view-dependent) + discovered custom columns ---
  const allColumns = useMemo(() => {
    const baseColumns = view === 'monthly' ? MONTHLY_COLUMNS : view === 'yearly' ? YEARLY_COLUMNS : DAILY_COLUMNS;
    const customCols = customColumnKeys.map((key) => ({
      key,
      label: prettifyKey(key),
      accessor: (d) => (d.customFields && d.customFields[key] !== undefined && d.customFields[key] !== null && d.customFields[key] !== ''
        ? d.customFields[key]
        : '—'),
      custom: true,
    }));
    return [...baseColumns, ...customCols];
  }, [view, customColumnKeys]);

  // --- keep visibleColumns in sync as columns are discovered / the view changes (default: visible) ---
  useEffect(() => {
    setVisibleColumns((prev) => {
      const next = { ...prev };
      let changed = false;
      allColumns.forEach((c) => {
        if (!(c.key in next)) {
          next[c.key] = true;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [allColumns]);

  const displayedColumns = useMemo(
    () => allColumns.filter((c) => visibleColumns[c.key]),
    [allColumns, visibleColumns]
  );

  const toggleColumnVisible = (key) => {
    setVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Analytics + chart series come straight from the server summary. Charts are
  // daily-bucketed server-side so the payload stays bounded regardless of range.
  const analytics = {
    ...summary.analytics,
    chartFlow: summary.chartFlow,
    chartConsumption: summary.chartConsumption,
  };

  const navigateToMeterDetails = (imei) => navigate(`/meter-details/${imei}`);

  // Human-readable label for the active period, used in the PDF header
  const periodLabel = () => {
    if (view === 'monthly') return selectedMonth && selectedMonth.value !== 'ALL' ? selectedMonth.label : 'All months';
    if (view === 'yearly') return selectedYear && selectedYear.value !== 'ALL' ? selectedYear.label : 'All years';
    if (view === 'daily') return singleDay || 'All dates';
    if (startDate || endDate) return `${startDate || '…'} to ${endDate || '…'}`;
    return 'All dates';
  };

  // Filesystem-safe base name for exports, consistent across every view
  const exportFileBase = () => {
    const meterPart = selectedMeter?.value || 'ALL';
    const base = view === 'monthly' ? 'monthly_consumption'
      : view === 'yearly' ? 'yearly_consumption'
      : 'consumption_report';
    const periodPart = view === 'monthly' ? (selectedMonth?.value || 'all-months')
      : view === 'yearly' ? (selectedYear?.value || 'all-years')
      : view === 'daily' ? (singleDay || 'all-days')
      : [startDate || 'start', endDate || 'end'].join('_');
    return [base, meterPart, periodPart].join('_');
  };

  // --- Export helpers take an explicit list of columns + rows to include, so they
  // work correctly whichever view (daily/monthly/yearly) is currently active ---
  const handleExportCSV = (cols, rows) => {
    if (!rows.length) return toast.warn('No data to export');
    if (!cols.length) return toast.warn('Select at least one column to export');

    const formattedData = rows.map((item) => {
      const row = {};
      cols.forEach((c) => {
        row[c.label] = c.accessor(item);
      });
      return row;
    });

    const csv = Papa.unparse(formattedData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${exportFileBase()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    toast.success('CSV exported successfully');
  };

  const handleExportPDF = (cols, rows) => {
    if (!rows.length) return toast.warn('No data to export');
    if (!cols.length) return toast.warn('Select at least one column to export');

    // NOTE: exporting-state is owned by confirmExport (the caller); don't toggle it here.
    try {
      const doc = new jsPDF('landscape');
      const pageWidth = doc.internal.pageSize.getWidth();

      const generatedAt = new Date().toLocaleString('en-GB', {
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: true,
      });

      const reportTitle = view === 'monthly' ? 'Monthly Consumption Report'
        : view === 'yearly' ? 'Yearly Consumption Report'
        : 'Consumption Report';

      doc.setFontSize(18);
      doc.setFont(undefined, 'bold');
      doc.text(reportTitle, pageWidth / 2, 16, { align: 'center' });

      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(100);
      doc.text(`Generated on ${generatedAt}`, pageWidth / 2, 23, { align: 'center' });
      doc.text(periodLabel(), pageWidth / 2, 28, { align: 'center' });
      doc.setTextColor(0);
      doc.text(`${rows.length} record${rows.length === 1 ? '' : 's'}`, pageWidth / 2, 33, { align: 'center' });

      const headers = [cols.map((c) => c.label)];
      const dataRows = rows.map((data) => cols.map((c) => c.accessor(data)));

      doc.autoTable({ head: headers, body: dataRows, startY: 39, styles: { fontSize: 9 }, headStyles: { fillColor: [0, 188, 212], textColor: 255, fontStyle: 'bold' }, margin: { top: 20 } });
      doc.save(`${exportFileBase()}.pdf`);
      toast.success('PDF exported successfully');
    } catch (err) {
      console.error(err);
      toast.error('Failed to export PDF');
    }
  };

  // Instead of exporting immediately, open the export column picker,
  // pre-selected with whatever is currently visible on screen.
  const handleExportSelection = (selectedOption) => {
    if (!selectedOption) return;
    setPendingExportFormat(selectedOption.value);
    setExportSelectedKeys(displayedColumns.map((c) => c.key));
    setShowExportPicker(true);
  };

  const toggleExportKey = (key) => {
    setExportSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  // Fetch the ENTIRE filtered set (all=true → backend skips pagination) so exports
  // aren't silently truncated to the current page.
  const fetchAllRows = async () => {
    const { from, to } = rowsDateFilter();
    const params = filterParams(from, to);
    params.set('view', apiView);
    params.set('all', 'true');
    const res = await fetch(`${IP_URL}/currentData/consumption-rows?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Failed to fetch rows for export');
    const data = await res.json();
    return data.rows || [];
  };

  const confirmExport = async () => {
    const cols = allColumns.filter((c) => exportSelectedKeys.includes(c.key));
    if (!cols.length) return toast.warn('Select at least one column to export');

    setExporting(true);
    try {
      const allRows = await fetchAllRows();
      if (!allRows.length) { toast.warn('No data to export'); return; }
      if (pendingExportFormat === 'csv') handleExportCSV(cols, allRows);
      if (pendingExportFormat === 'pdf') handleExportPDF(cols, allRows);
    } catch (err) {
      console.error(err);
      toast.error('Failed to prepare export');
    } finally {
      setExporting(false);
      setShowExportPicker(false);
      setPendingExportFormat(null);
    }
  };

  return (
    <Main>
      <Navbar showMenuButton={true} toggleSidebar={toggleSidebar} />
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <Container>
        <HeaderRow>
          <PageTitle>
            <h1>Consumption Report</h1>
            <p>Analyze meter consumption and flow rates, with daily readings and monthly summaries.</p>
          </PageTitle>
          <ExportGroup>
            <ExportButton onClick={() => handleExportSelection({ value: 'csv' })} disabled={loading || exporting}>
              ⭳ CSV
            </ExportButton>
            <ExportButton $primary onClick={() => handleExportSelection({ value: 'pdf' })} disabled={loading || exporting}>
              ⭳ PDF
            </ExportButton>
          </ExportGroup>
        </HeaderRow>

        <ControlsBar>
          <Field $wide>
            <label>Meter</label>
            <Select
              options={meterOptions}
              value={selectedMeter}
              onChange={(v) => { setSelectedMeter(v); setPage(1); }}
              styles={neutralSelectStyles}
              placeholder="All meters"
              isClearable
            />
          </Field>

          <Field>
            <label>View</label>
            <select
              value={view}
              onChange={(e) => { setView(e.target.value); setPage(1); setRows([]); setLoading(true); }}
            >
              <option value="range">Date Range</option>
              <option value="daily">Single Day</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
            </select>
          </Field>

          {view === 'range' && (
            <>
              <Field>
                <label>Start Date</label>
                <input type="date" value={startDate} onChange={(e)=>{ setStartDate(e.target.value); setPage(1); }} />
              </Field>
              <Field>
                <label>End Date</label>
                <input type="date" value={endDate} onChange={(e)=>{ setEndDate(e.target.value); setPage(1); }} />
              </Field>
            </>
          )}

          {view === 'daily' && (
            <Field>
              <label>Day</label>
              <input type="date" value={singleDay} onChange={(e)=>{ setSingleDay(e.target.value); setPage(1); }} />
            </Field>
          )}

          {view === 'monthly' && (
            <Field>
              <label>Month</label>
              <Select
                options={monthOptions}
                value={selectedMonth}
                onChange={(v) => { setSelectedMonth(v); setPage(1); }}
                styles={neutralSelectStyles}
                placeholder="All months"
                isClearable
              />
            </Field>
          )}

          {view === 'yearly' && (
            <Field>
              <label>Year</label>
              <Select
                options={yearOptions}
                value={selectedYear}
                onChange={(v) => { setSelectedYear(v); setPage(1); }}
                styles={neutralSelectStyles}
                placeholder="All years"
                isClearable
              />
            </Field>
          )}

          <Field>
            <label>&nbsp;</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <Button onClick={()=>{ setStartDate(''); setEndDate(''); setSingleDay(''); setSelectedMeter(null); setSelectedMonth(null); setSelectedYear(null); setPage(1); }}>Reset</Button>
              <Button onClick={() => setRefreshTick((t) => t + 1)}>Refresh</Button>
            </div>
          </Field>
        </ControlsBar>

        {/* analytics cards */}
        <Cards>
          <Card>
            <strong>Total Consumption</strong>
            <div style={{fontSize:20}}>{analytics.totalConsumption} m³</div>
            <small>{periodLabel()}</small>
          </Card>

          <Card>
            <strong>Avg Flowrate</strong>
            <div style={{fontSize:20}}>{analytics.avgFlowRate} m³/hr</div>
            <small>Based on {analytics.pointsCount} data points</small>
          </Card>

          <Card>
            <strong>Peak Flowrate</strong>
            <div style={{fontSize:20}}>{analytics.peakFlowRate} m³/hr</div>
            <small>Highest observed</small>
          </Card>

          <Card>
            <strong>Data Points</strong>
            <div style={{fontSize:20}}>{analytics.pointsCount}</div>
            <small>Records in selection</small>
          </Card>
        </Cards>

        {/* charts */}
        <DataContainers >
          <h4>Flowrate (time-series)</h4>
          {analytics.chartFlow.length ? (
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={analytics.chartFlow}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" tick={{fontSize:11}} minTickGap={20} />
                <YAxis label={{ value: 'm³/hr', angle: -90, position: 'insideLeft' }} />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="flow_m3_hr" stroke="#1f8ef1" dot={false} strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          ) : <p>No flowrate data for selected range.</p>}
        </DataContainers>

        <DataContainers >
          <h4>Consumption & Cumulative</h4>
          {analytics.chartConsumption.length ? (
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={analytics.chartConsumption}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" tick={{fontSize:11}} />
                <YAxis />
                <Tooltip />
                <Area type="monotone" dataKey="consumption_m3" name="Daily consumption (m³)" stroke="#22a28f" fill="#36f1ccff" />
                <Area type="monotone" dataKey="cumulative_m3" name="Cumulative (m³)" stroke="#007bff" fill="#cfe7ff" />
              </AreaChart>
            </ResponsiveContainer>
          ) : <p>No consumption data for selected range.</p>}
        </DataContainers>

        {/* table + filtering row */}
        <Content>
           <h4>{view === 'monthly' ? 'Monthly Consumption Summary' : view === 'yearly' ? 'Yearly Consumption Summary' : view === 'daily' ? 'Single-Day Readings' : 'Consumption Readings'}</h4>

           <TableToolbar>
             <div style={{ position: 'relative', marginLeft: 'auto' }}>
               <Button onClick={() => setShowColumnPicker((v) => !v)}>
                 Columns ({displayedColumns.length}/{allColumns.length})
               </Button>

               {showColumnPicker && (
                 <ColumnPickerPanel>
                   <PanelHeading>Standard columns</PanelHeading>
                   {allColumns.filter((c) => !c.custom).map((c) => (
                     <CheckboxRow key={c.key}>
                       <input
                         type="checkbox"
                         checked={!!visibleColumns[c.key]}
                         onChange={() => toggleColumnVisible(c.key)}
                       />
                       {c.label}
                     </CheckboxRow>
                   ))}

                   {allColumns.some((c) => c.custom) && (
                     <>
                       <PanelHeading style={{ marginTop: 10 }}>Custom columns</PanelHeading>
                       {allColumns.filter((c) => c.custom).map((c) => (
                         <CheckboxRow key={c.key}>
                           <input
                             type="checkbox"
                             checked={!!visibleColumns[c.key]}
                             onChange={() => toggleColumnVisible(c.key)}
                           />
                           {c.label}
                         </CheckboxRow>
                       ))}
                     </>
                   )}
                 </ColumnPickerPanel>
               )}
             </div>
           </TableToolbar>

          {loading ? <p>Loading...</p> : (
            <Table>
              <thead>
                <tr>
                  {displayedColumns.map((c) => (
                    <th key={c.key}>{c.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableRows.length > 0 ? tableRows.map((data, index) => (
                  <tr key={index} onClick={() => navigateToMeterDetails(data.imei || data.meterId)}>
                    {displayedColumns.map((c) => (
                      <td key={c.key}>{c.accessor(data)}</td>
                    ))}
                  </tr>
                )) : (
                  <tr><td colSpan={displayedColumns.length || 1}>No data available for selected filters</td></tr>
                )}
              </tbody>
            </Table>
          )}

          {/* server-side pagination controls */}
          {!loading && total > 0 && (
            <PaginationBar>
              <span className="info">
                {(page - 1) * limit + 1}–{Math.min(page * limit, total)} of {total.toLocaleString()}
              </span>
              <div className="controls">
                <label>
                  Rows:&nbsp;
                  <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }}>
                    {[25, 50, 100, 200].map((n) => <option key={n} value={n}>{n}</option>)}
                  </select>
                </label>
                <Button disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Prev</Button>
                <span className="page">Page {page} of {Math.max(1, Math.ceil(total / limit))}</span>
                <Button
                  disabled={page >= Math.ceil(total / limit)}
                  onClick={() => setPage((p) => (p < Math.ceil(total / limit) ? p + 1 : p))}
                >Next</Button>
              </div>
            </PaginationBar>
          )}
        </Content>
      </Container>

      {/* Export column selection modal */}
      {showExportPicker && (
        <ModalOverlay onClick={() => setShowExportPicker(false)}>
          <ModalBox onClick={(e) => e.stopPropagation()}>
            <h3>Choose columns to export</h3>

            <PanelHeading>Standard columns</PanelHeading>
            {allColumns.filter((c) => !c.custom).map((c) => (
              <CheckboxRow key={c.key}>
                <input
                  type="checkbox"
                  checked={exportSelectedKeys.includes(c.key)}
                  onChange={() => toggleExportKey(c.key)}
                />
                {c.label}
              </CheckboxRow>
            ))}

            {allColumns.some((c) => c.custom) && (
              <>
                <PanelHeading style={{ marginTop: 10 }}>Custom columns</PanelHeading>
                {allColumns.filter((c) => c.custom).map((c) => (
                  <CheckboxRow key={c.key}>
                    <input
                      type="checkbox"
                      checked={exportSelectedKeys.includes(c.key)}
                      onChange={() => toggleExportKey(c.key)}
                    />
                    {c.label}
                  </CheckboxRow>
                ))}
              </>
            )}

            <ModalActions>
              <Button danger onClick={() => setShowExportPicker(false)}>Cancel</Button>
              <Button onClick={confirmExport} disabled={exporting}>
                Export {pendingExportFormat?.toUpperCase()}
              </Button>
            </ModalActions>
          </ModalBox>
        </ModalOverlay>
      )}

      <Footer />
      
    </Main>
  );
};

export default ConsumptionReport;